import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { DeleteLeadItem, UpdateLeadItem } from '../../../store/actions/new/leadDataAction';
import NoContentFound from '../../default/not-found/notFound';
import { ShimmerTable } from 'react-shimmer-effects';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const EntryList = ({ entries, onAdd, onChange, onRemove, entryType, placeholder }) => {
    return (
        <>
            {entries.map((entry, index) => (
                <div className="sng-content-repeater d-right-auto" key={index}>
                    <div className="sng-content">
                        <label>Type</label>
                        <input
                            type="text"
                            className="sett-form-input"
                            placeholder="Type"
                            value={entry.title || ''}
                            onChange={(e) => onChange(index, 'title', e.target.value)}
                        />
                    </div>
                    <div className="sng-content">
                        <label>{entryType}</label>
                        <input
                            type="text"
                            className="sett-form-input"
                            placeholder={placeholder}
                            value={entry.value || ''}
                            onChange={(e) => onChange(index, 'value', e.target.value)}
                        />
                    </div>
                    {entries.length > 1 && (
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => onRemove(index, entry.id)}
                        >
                            <i className="ri-subtract-fill"></i>
                        </button>
                    )}
                </div>
            ))}
            <div className="sng-content-repeater add-field-button">
                <button type="button" className="add-new-field" onClick={onAdd}>
                    <i className="ri-add-line"></i> Add
                </button>
            </div>
        </>
    );
};

const UpdateLead = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [title, setTitle] = useState('');
    const [company, setCompany] = useState('');
    const [emailEntries, setEmailEntries] = useState([{ id: '', type: '', title: '', value: '' }]);
    const [phoneEntries, setPhoneEntries] = useState([{ id: '', type: '', title: '', value: '' }]);
    const [websiteEntries, setWebsiteEntries] = useState([{ id: '', type: '', title: '', value: '' }]);
    const [addressEntries, setAddressEntries] = useState([{ id: '', type: '', title: '', value: '' }]);
    const [notesEntries, setNotesEntries] = useState([{ id: '', type: '', title: '', value: '' }]);
    const [typeDeleted, setTypeDeleted] = useState([]);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const { id } = useParams();
    const [cardId, setCardId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [leadData, setLeadData] = useState(null);

    const store = useSelector((state) => state.leadDataReducer);
    const { data } = store.leadAllData;
    const leadDataList = leadData || '';
    useEffect(() => {
        if (leadData && leadData.adi_info) {
            setFirstName(leadData.firstName)
            setLastName(leadData.lastName)
            setTitle(leadData.title)
            setCompany(leadData.company)
            const entryTypes = ['email', 'phone', 'website', 'address', 'note']; // Define the types you want to process

            entryTypes.forEach(type => {
                if (leadData.adi_info[type]) {
                    const formattedEntries = leadData.adi_info[type].map(entry => ({
                        id: entry.id || '',
                        type: entry.type || '',
                        title: entry.title || '',
                        value: entry.value || ''
                    }));

                    // Set the state based on the type
                    switch (type) {
                        case 'email':
                            setEmailEntries(formattedEntries);
                            break;
                        case 'phone':
                            setPhoneEntries(formattedEntries);
                            break;
                        case 'website':
                            setWebsiteEntries(formattedEntries);
                            break;
                        case 'address':
                            setAddressEntries(formattedEntries);
                            break;
                        case 'note':
                            setNotesEntries(formattedEntries);
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    }, [leadData]);

    useEffect(() => {
        setCardId(id);
        const fetchCardData = async () => {
            if (data && data.length > 0) {
                const foundData = data.find(item => item.ID === id);
                if (foundData) {
                    setLeadData(foundData);
                    setIsLoading(false)
                } else {
                    try {
                        const response = await axios.get(`/prospector?id=${id}`);
                        if (response.data && response.data.data && response.data.data.length > 0) {
                            setLeadData(response.data.data[0]);
                            setIsLoading(false)
                        } else {
                            setLeadData(null);
                            setIsLoading(false)
                        }
                    } catch (error) {
                        console.error('Error fetching card data:', error);
                        setLeadData(null);
                        setIsLoading(false)
                    }
                }
            } else {
                try {
                    const response = await axios.get(`/prospector?id=${id}`);
                    if (response.data && response.data.data && response.data.data.length > 0) {
                        setLeadData(response.data.data[0]);
                        setIsLoading(false)
                    } else {
                        setLeadData(null);
                        setIsLoading(false)
                    }
                } catch (error) {
                    console.error('Error fetching card data:', error);
                    setLeadData(null);
                    setIsLoading(false)
                }
            }
        };

        fetchCardData();
    }, [id]);
    const handleAddEntry = (type) => {
        const settersMap = {
            email: setEmailEntries,
            phone: setPhoneEntries,
            website: setWebsiteEntries,
            address: setAddressEntries,
            note: setNotesEntries,
        };

        settersMap[type]((prev) => [...prev, { type: '', value: '' }]);
    };

    const handleChange = (type, index, field, value) => {
        const settersMap = {
            email: setEmailEntries,
            phone: setPhoneEntries,
            website: setWebsiteEntries,
            address: setAddressEntries,
            note: setNotesEntries,
        };

        settersMap[type]((prevEntries) => {
            const newEntries = [...prevEntries];
            newEntries[index] = {
                ...newEntries[index],
                [field]: value
            };
            return newEntries;
        });
        // Clear errors when user starts typing
        if (errors[type]) {
            setErrors(prev => ({ ...prev, [type]: '' }));
        }
    };

    const handleRemove = (type, index, itemID) => {
        const settersMap = {
            email: setEmailEntries,
            phone: setPhoneEntries,
            website: setWebsiteEntries,
            address: setAddressEntries,
            note: setNotesEntries,
        };
        // const itemValidID = itemID
        // // Check if the id is not blank and store the id and type in typeDeleted
        if (itemID !== undefined) { // Check if itemID is valid
            setTypeDeleted((prev) => [
                ...prev,
                itemID
            ]);
            // console.log(typeDeleted)
        }

        settersMap[type]((prevEntries) => {
            return prevEntries.filter((_, i) => i !== index);
        });

    };
    const validateForm = () => {
        const newErrors = {};

        if (!firstName.trim()) {
            newErrors.firstName = 'First name is required';
        }

        if (!lastName.trim()) {
            newErrors.lastName = 'Last name is required';
        }

        // Check if at least one email is provided
        // const hasValidEmail = emailEntries.some(entry => entry.value && entry.value.trim());
        // if (!hasValidEmail) {
        //     newErrors.email = 'At least one email is required';
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        // Format the additional info entries
        const formatEntries = (entries, type) => {
            return entries.map(entry => ({
                type,
                title: entry.title || type,
                value: entry.value
            })).filter(entry => entry.value);
        };

        // Combine all additional info entries
        const adi_info_add = [
            ...formatEntries(phoneEntries, 'phone'),
            ...formatEntries(emailEntries, 'email'),
            ...formatEntries(websiteEntries, 'website'),
            ...formatEntries(addressEntries, 'address'),
            ...formatEntries(notesEntries, 'note')
        ];
        const adi_info_del = [...typeDeleted]

        const formData = {
            id,
            firstName,
            lastName,
            title,
            company,
            adi_info_add,
            adi_info_del
        };

        // dispatch the action
        try {
            const response = await dispatch(UpdateLeadItem(formData));
            if (response.status >= 200 && response.status < 300) {
                setTypeDeleted([]);
                setLeadData(response.data.data);
            } else {
                console.error('Failed to add new lead:', response);
            }
        } catch (error) {
            console.error('Error dispatching AddNewLead:', error);
        }


    };

    // Delete lead
    const MySwal = withReactContent(Swal)
    const handleDeleteLead = () => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await dispatch(DeleteLeadItem(id));
                    if (response?.status === 200) {
                        navigate('/lead');
                    }
                } catch (error) {
                    console.error('Error deleting lead:', error);
                }
            }
        });

    }
    return (
        <>
            {leadData && isLoading === false ? (
                <form onSubmit={handleSubmit}>
                    <div className="settings-list-wrapper">
                        <div class="connection-header settings-header">
                            <h3>Lead update</h3>
                        </div>
                        <div className="single-settings" id="basic-info">
                            <h5 className="setting-title">Basic info</h5>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <label>First name</label>
                                        <input
                                            className={`sett-form-input ${errors.firstName ? 'border-red-500' : ''}`}
                                            value={firstName}
                                            onChange={(e) => {
                                                setFirstName(e.target.value);
                                                if (errors.firstName) {
                                                    setErrors(prev => ({ ...prev, firstName: '' }));
                                                }
                                            }}
                                            placeholder="e.g. John"
                                        />
                                        {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <label>Last name</label>
                                        <input
                                            className={`sett-form-input ${errors.lastName ? 'border-red-500' : ''}`}
                                            value={lastName}
                                            onChange={(e) => {
                                                setLastName(e.target.value);
                                                if (errors.lastName) {
                                                    setErrors(prev => ({ ...prev, lastName: '' }));
                                                }
                                            }}
                                            placeholder="e.g. Doe"
                                        />

                                        {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <label>Title</label>
                                        <input
                                            type="text"
                                            className="sett-form-input"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Title"
                                        />
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <label>Company</label>
                                        <input
                                            type="text"
                                            className="sett-form-input"
                                            value={company}
                                            onChange={(e) => setCompany(e.target.value)}
                                            placeholder="Cardiast"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single-settings hide-lebel" id="email-section">
                            <h5 className="setting-title">Email</h5>
                            <div className={`setting-content ${errors.lastName ? 'mail-error' : ''}`}>
                                <EntryList
                                    entries={emailEntries}
                                    onAdd={() => handleAddEntry('email')}
                                    onChange={(index, field, value) => handleChange('email', index, field, value)}
                                    onRemove={(index, itemID) => handleRemove('email', index, itemID)}
                                    entryType="Email"
                                    placeholder="e.g. info@yourmail.com"
                                />
                                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                            </div>
                        </div>
                        <div className="single-settings hide-lebel" id="phone-section">
                            <h5 className="setting-title">Phone</h5>
                            <div className="setting-content">
                                <EntryList
                                    entries={phoneEntries}
                                    onAdd={() => handleAddEntry('phone')}
                                    onChange={(index, field, value) => handleChange('phone', index, field, value)}
                                    onRemove={(index, itemID) => handleRemove('phone', index, itemID)}
                                    entryType="Phone"
                                    placeholder="e.g. 123-456-7890"
                                />
                            </div>
                        </div>
                        <div className="single-settings hide-lebel" id="website-section">
                            <h5 className="setting-title">Websites</h5>
                            <div className="setting-content">
                                <EntryList
                                    entries={websiteEntries}
                                    onAdd={() => handleAddEntry('website')}
                                    onChange={(index, field, value) => handleChange('website', index, field, value)}
                                    onRemove={(index, itemID) => handleRemove('website', index, itemID)}
                                    entryType="Website"
                                    placeholder="e.g. www.yourwebsite.com"
                                />
                            </div>
                        </div>
                        <div className="single-settings hide-lebel" id="address-section">
                            <h5 className="setting-title">Address</h5>
                            <div className="setting-content">
                                <EntryList
                                    entries={addressEntries}
                                    onAdd={() => handleAddEntry('address')}
                                    onChange={(index, field, value) => handleChange('address', index, field, value)}
                                    onRemove={(index, itemID) => handleRemove('address', index, itemID)}
                                    entryType="Address"
                                    placeholder="e.g. 123 Main St"
                                />
                            </div>
                        </div>
                        <div className="single-settings hide-lebel" id="notes-section">
                            <h5 className="setting-title">Notes</h5>
                            <div className="setting-content">
                                <EntryList
                                    entries={notesEntries}
                                    onAdd={() => handleAddEntry('note')}
                                    onChange={(index, field, value) => handleChange('note', index, field, value)}
                                    onRemove={(index, itemID) => handleRemove('note', index, itemID)}
                                    entryType="Note"
                                    placeholder="e.g. Important note"
                                />
                            </div>
                        </div>
                        <div className="single-settings border-none">
                            <label className="setting-title">More actions</label>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content copy-wrapper">
                                        <button type='button' className="btn delete-btn" onClick={(e) => handleDeleteLead(e)}><i className="ri-delete-bin-line"></i> Delete Contact</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="button-wrapper form-error-wrapper">
                            {(errors.firstName || errors.lastName || errors.email) && <p className="text-red-500 text-sm mt-1">Please fill all the required fields.</p>}
                            <button type="submit" className="btn submit-btn bg-primary">Submit</button>
                        </div>
                    </div>
                </form>
            ) : isLoading === false && (
                <NoContentFound title="Invalid card ID" />
            )}
            {isLoading &&
                <>
                    <ShimmerTable row={10} col={3} />
                </>
            }
        </>
    );
};

export default UpdateLead;